import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PREMIUM } from "../../MyConst";
import SpecialReviewOnlyForPremium from "./SpecialReviewOnlyForPremium";
import { fetchReviewSettingAdditionalComment } from "./sliceReviewSettingAdditionalComment";
import { fetchReviewSettingDays } from "./sliceReviewSettingDays";
import ReviewSettingAdditionalComment from "./ReviewSettingAdditionalComment";
import ReviewSettingDays from "./ReviewSettingDays";
import useAuth from "../../hooks/useAuth";
import { CEO_TYPES } from "../../constants/AppConstants";

export default function ReviewSetting() {
  const dispatch = useDispatch();
  const { ceoInfo } = useAuth();
  const ceoType = ceoInfo?.ceo_type;
  const [additionList, setAdditionList] = useState([])



  useEffect(
    function () {
      if (ceoType === PREMIUM) {
        dispatch(fetchReviewSettingAdditionalComment());
        dispatch(fetchReviewSettingDays());
      }
    },
    [ceoType]
  );

  if (ceoType === CEO_TYPES.NORMAL) {
    return (
      <div className="flex flex-col">
        <SpecialReviewOnlyForPremium />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 pt-2" style={{ background: "#e6eaf2" }}>
      <ReviewSettingDays setAdditionList={setAdditionList} />
      <ReviewSettingAdditionalComment additionList={additionList} setAdditionList={setAdditionList}  />
    </div>
  );
}
